export default {"src":"/_next/static/media/add.99e5b213.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};